// extracted by mini-css-extract-plugin
export default {"description":"Email_description__aU4jM","invalid":"Email_invalid__zxrCZ","invalidList":"Email_invalidList__ZZvIR","item":"Email_item__If2rZ"};